module.exports = __webpack_public_path__ + "static/media/quickOrderStateChangeTutorial.b0800730.svg";